import { SignIn, SignUp } from "@clerk/clerk-react";
import { Box, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { routes } from "schemas/routes";

import { AuthAction } from "features/Auth/schema";

import { getRedirectUrl } from "../../helpers";

interface Props {
  action: AuthAction;
}

const VaAnnualAuth = ({ action }: Props) => {
  const location = useLocation();
  const redirectUrl = getRedirectUrl(routes.vaAnnual, location);

  const appearance = {
    elements: {
      card: {
        boxShadow: "none",
        border: "1px solid #E0E0E0",
      },
    },
  };

  return (
    <Box sx={{ py: 3 }}>
      <Typography textAlign={"center"} gutterBottom>
        <Box component="span" sx={{ fontSize: { xs: 20, md: 30 } }}>
          Create a Bento Account
        </Box>
      </Typography>
      <Typography sx={{ mb: 3 }} textAlign={"center"}>
        If you already have a Bento Account, simply login{" "}
      </Typography>

      <Grid container justifyContent="center">
        {action === AuthAction.SIGN_UP && (
          <SignUp
            appearance={appearance}
            signInUrl={`/${routes.vaAnnualSignIn}`}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
        {action === AuthAction.SIGN_IN && (
          <SignIn
            appearance={appearance}
            signUpUrl={`/${routes.vaAnnualSignUp}`}
            afterSignUpUrl={redirectUrl}
            afterSignInUrl={redirectUrl}
          />
        )}
      </Grid>
    </Box>
  );
};

export default VaAnnualAuth;
